import { GridCellProps } from "@progress/kendo-react-grid";

export default function DinerCell(gridProps: GridCellProps) {
    const { dataItem } = gridProps;
    const field = gridProps.field || '';
    const dataValue = dataItem[field] === null ? 0 : dataItem[field];
    const heures = Math.floor(dataValue);
    const minutes = ((dataValue % 1) * 100);
    const heuresString = heures > 0 ? `${String(heures)}h` : "";
    const minutesString = `${minutes}m`
    return <td>{heuresString + minutesString}</td>;
}